export class Accepted extends Error {
  constructor() {
    super('Accepted');
    this.name = 'Accepted';
  }
}
